import { Link } from "react-router-dom";
import { ArrowRight, Briefcase, Home as HomeIcon } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const marqueeItems = [
  "Gestion administrative", "Facturation", "Pré-comptabilité", "Assistance RH",
  "Organisation documentaire", "Dématérialisation", "Démarches en ligne", "Suivi d'activité",
];

export const Marquee = () => (
  <section className="border-y border-[#2C2A29]/10 bg-argia-stone py-5 overflow-hidden" data-testid="marquee-section">
    <div className="marquee-track flex w-max items-center gap-8 whitespace-nowrap">
      {[...marqueeItems, ...marqueeItems].map((item, i) => (
        <span key={`${item}-${i < marqueeItems.length ? "a" : "b"}`} className="flex items-center gap-8 font-display text-lg italic text-argia-ink/70">
          {item}
          <span className="h-1.5 w-1.5 rounded-full bg-argia-gold" />
        </span>
      ))}
    </div>
  </section>
);

export const Problem = () => (
  <section className="mx-auto max-w-7xl px-6 py-24 lg:px-10">
    <div className="grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal>
          <SectionLabel>Le constat</SectionLabel>
          <h2 className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-argia-ink sm:text-4xl lg:text-5xl">
            Votre administratif vous prend trop de temps ?
          </h2>
        </Reveal>
      </div>
      <div className="lg:col-span-6 lg:col-start-7">
        <Reveal delay={0.15}>
          <p className="text-base leading-relaxed text-argia-muted md:text-lg">
            Factures en attente, dossiers à traiter, documents éparpillés, démarches complexes :
            l'administratif devient vite chronophage, source de stress et de retard.
          </p>
          <p className="mt-5 text-base leading-relaxed text-argia-muted md:text-lg">
            ARGIA Admin vous apporte un accompagnement personnalisé pour retrouver une gestion
            administrative <span className="font-semibold text-argia-ink">claire, structurée et efficace</span>.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);

const SolutionCard = ({ to, testId, dark, icon: Icon, title, children }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group block h-full rounded-2xl p-10 transition-all duration-300 hover:-translate-y-1 ${
      dark ? "bg-argia-ink hover:shadow-2xl" : "border border-[#2C2A29]/10 bg-[#FDFBF7] hover:shadow-xl"
    }`}
  >
    <Icon size={32} strokeWidth={1.5} className={dark ? "text-argia-gold" : "text-argia-red"} />
    <h3 className={`mt-6 font-display text-2xl font-bold md:text-3xl ${dark ? "text-white" : "text-argia-ink"}`}>{title}</h3>
    <p className={`mt-4 text-base leading-relaxed ${dark ? "text-white/70" : "text-argia-muted"}`}>{children}</p>
    <span className={`mt-8 inline-flex items-center gap-2 text-sm font-semibold ${dark ? "text-argia-gold" : "text-argia-red"}`}>
      En savoir plus
      <ArrowRight size={16} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
    </span>
  </Link>
);

export const Solutions = () => (
  <section className="bg-argia-stone py-24" data-testid="solutions-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="text-center">
        <SectionLabel>Mes solutions</SectionLabel>
        <h2 className="mx-auto mt-5 max-w-2xl font-display text-3xl font-bold tracking-tight text-argia-ink sm:text-4xl lg:text-5xl">
          Deux accompagnements, une même exigence
        </h2>
      </Reveal>
      <div className="mt-16 grid gap-8 lg:grid-cols-2">
        <Reveal delay={0.1}>
          <SolutionCard to="/services" testId="card-pros" dark icon={Briefcase} title="Pour les professionnels">
            Artisans, commerçants, indépendants, professions libérales, associations, TPE :
            gestion administrative, facturation, pré-comptabilité, assistance RH, organisation documentaire,
            dématérialisation et suivi de votre activité.
          </SolutionCard>
        </Reveal>
        <Reveal delay={0.25}>
          <SolutionCard to="/services" testId="card-particuliers" icon={HomeIcon} title="Pour les particuliers">
            Constitution de dossiers administratifs, démarches en ligne, courriers, organisation de vos
            documents et formalités du quotidien : je vous simplifie la vie, en toute sérénité.
          </SolutionCard>
        </Reveal>
      </div>
    </div>
  </section>
);
